import { render, staticRenderFns } from "./data_correction.vue?vue&type=template&id=2b3ffd9e&scoped=true"
import script from "./data_correction.vue?vue&type=script&lang=js"
export * from "./data_correction.vue?vue&type=script&lang=js"
import style0 from "./data_correction.vue?vue&type=style&index=0&id=2b3ffd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ffd9e",
  null
  
)

export default component.exports